import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import moment from 'moment';
import 'moment/locale/th';

import { useTranslation } from 'react-i18next';

// ui
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// style
import tableIcons from '../../../components/table/MaterialTableIcon';

import WaterLevelColor from '../../../components/color/waterlevel/WaterLevelColor';

// Utils
import exportCsv from '../../../utils/export/Csv';

export default function WaterLavelDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('ชื่อสถานี'),
            title_export: t('ชื่อสถานี'),
            field: 'tele_station_name',
            width: 250,
            headerStyle: {
              left: 0,
              position: 'sticky',
              zIndex: 50,
              backgroundColor: '#CCCCCC',
            },
            cellStyle: {
              backgroundColor: '#fff',
              left: 0,
              position: 'sticky',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              textAlign: 'left',
            },
            render: (row) => (
              `${row.tele_station_oldcode} ${row.tele_station_name}`
            ),
            customSort: (a, b) => a.title.localeCompare(b.title, 'th'),
          },
          {
            title_export: t('ตำบล'),
            type: 'string',
            field: 'tumbon_name',
            hidden: true,
          },
          {
            title_export: t('อำเภอ'),
            type: 'string',
            field: 'amphoe_name',
            hidden: true,
          },
          {
            title: t('ที่ตั้ง'),
            title_export: t('ที่ตั้ง'),
            field: 'province_name',
            type: 'string',
            width: 300,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => (`${t('ต.')}${row.tumbon_name} ${t('อ.')}${row.amphoe_name} ${t('จ.')}${row.province_name}`),
          },
          {
            title: t('ลุ่มน้ำ'),
            title_export: t('ลุ่มน้ำ'),
            type: 'string',
            field: 'basin_name',
            width: 200,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            // hidden: !userIsLogin,
          },
          {
            title: t('เวลา'),
            title_export: t('เวลา'),
            field: 'waterlevel_datetime',
            type: 'date',
            width: 80,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${moment(row.waterlevel_datetime).format('HH:mm')} น.`,
          },
          {
            title:
  <>
    {t('ระดับน้ำ')}
    <br />
    <Typography variant="caption" display="block">({t('ม.รทก.')})</Typography>
  </>,
            title_export: t('ระดับน้ำ (ม.รทก)'),
            field: 'waterlevel_msl',
            type: 'numeric',
            width: 80,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.waterlevel_msl}`,
          },
          {
            title:
  <>
    {t('ระดับตลิ่ง')}
    <br />
    <Typography variant="caption" display="block">({t('ม.รทก.')})</Typography>
  </>,
            title_export: t('ระดับตลิ่ง (ม.รทก)'),
            field: 'min_bank',
            type: 'numeric',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            export: false,
          },
          //           {
          //             title:
          // <>
          //   ค่าศูนย์เสาระดับ
          //   <br />
          //   <Typography variant="caption" display="block">(ม.รทก)</Typography>
          // </>,
          //             title_export: 'ระดับตลิ่ง (ม.รทก)',
          //             field: 'bank',
          //             type: 'numeric',
          //             width: 100,
          //             export: false,
          //             render: (row) => (
          //               <>
          //                 {row.station.offset !== null ?
          // parseFloat(row.station.offset).toFixed(2) : '-'}
          //               </>
          //             ),
          //           },

          {
            title: t('หน่วยงาน'),
            title_export: t(' หน่วยงาน'),
            field: 'agency_name',
            type: 'string',
            hidden: true,
            export: false,
          },
          {
            title: t('% ความจุลำน้ำ'),
            title_export: t('% ความจุลำน้ำ'),
            field: 'storage_percent',
            type: 'numeric',
            width: 100,
            export: false,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.storage_percent}`,
          },
          {
            title: t('สถานการณ์'),
            title_export: t('สถานการณ์'),
            field: 'situation',
            type: 'string',
            width: 115,
            export: false,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => {
              const status = WaterLevelColor(row.storage_percent);

              return (
                <Box
                  borderRadius={3}
                  style={{
                    align: 'center',
                    textAlign: 'center',
                    margin: '0 auto',
                    width: '50px',
                    backgroundColor: status.color.statusColor,
                    color: status.color.constrastColor,
                  }}
                >
                  {status.color.label}
                </Box>
              );
            },
          },
        ]}
        data={datas}
        localization={{
          toolbar: {
            searchPlaceholder: t('ค้นหา'),
            exportTitle: t('ดาวน์โหลดข้อมูล ระดับน้ำ'),
          },
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: true,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

WaterLavelDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
